import { ReactElement } from 'react';

import { Dropdown } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { visitHistoryTranslationKeys } from '../../translations';

import { PrintOrShareVisitDocumentsShowModalEventInterceptor } from './interceptors/PrintOrShareVisitDocumentsShowModalEventInterceptor';

type PrintOrShareVisitDocumentsDropdownItemProps = {
   readonly visitId: number;
   readonly patientId: number;
};

export const PrintOrShareVisitDocumentsDropdownItem = (
   props: PrintOrShareVisitDocumentsDropdownItemProps
): ReactElement => {
   return (
      <PrintOrShareVisitDocumentsShowModalEventInterceptor patientId={props.patientId} visitId={props.visitId}>
         <Dropdown.Item testId={'printOrShareVisitDocuments'} onClick={(hide) => hide()}>
            {protectFeature(
               'sendingDocumentsToPatient',
               visitHistoryTranslationKeys.options.printOrShareVisitDocuments,
               visitHistoryTranslationKeys.options.printVisitDocuments
            )}
         </Dropdown.Item>
      </PrintOrShareVisitDocumentsShowModalEventInterceptor>
   );
};
